/**
 * Display boolean value as "Yes" or "No"
 */
export const displayBoolean = (value: boolean): string => (value ? 'Yes' : 'No');
